/* eslint-disable no-use-before-define */
import React, { Fragment, useEffect, useState } from 'react'
import { func, object } from 'prop-types'
import EscolhaCartoesExistentes from './EscolhaCartoesExistentes'
import EscolhaNovoCartao from './EscolhaNovoCartao'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import { useCartaoCredito } from '../../../contexts/CartaoCreditoContext'
import { isEmptyObject } from '../../../utils/helpers/helpers'
import { DESCRICAO_ESCOLHA_CARTAO_CREDITO, DESCRICAO_ESCOLHA_CARTAO_NOVO, ID_ADICIONAR_NOVO_CARTAO, ETAPA_PLANO, PARCELA_PADRAO_ANUAL, PARCELA_PADRAO_TRIMESTRAL } from '../constantsFluxosPagamento'
import { METODO_PAGAMENTO_CARTAO, PLANO_ANUAL } from '../../../constants'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'
import { tiposDePlanos } from '../../../containers/Modalidade/Plano/constantsPlano'
import { useModalidade } from '../../../contexts/ModalidadeContext'
import { useGlobal } from '../../../contexts/GlobalContext'

const PagamentoComCartaoCredito = ( { setCadastrouNovoCartao, setPagamentoSelecionado } ) => {
  const { cartoesCadastrados } = useCartaoCredito()
  const { temaFluxo, dadosEtapas } = useFluxosPagamento()
  const [ idCartaoDeCreditoSelecionado, setIdCartaoDeCreditoSelecionado ] = useState()
  const [ novoCartaoCredito, setNovoCartaoCredito ] = useState( {} )
  const { listaPlanosPorModalidade } = useModalidade()
  const { setValidCaptcha } = useGlobal()

  useEffect( () => {
    let cartaoSelecionado
    setPagamentoSelecionado( null )

    if ( idCartaoDeCreditoSelecionado ) {
      const cartaoCredito = cartoesCadastrados.find( cartao => cartao.id === idCartaoDeCreditoSelecionado )
      if ( cartaoCredito && idCartaoDeCreditoSelecionado === cartaoCredito.id ) {
        cartaoSelecionado = cartaoCredito
        setCadastrouNovoCartao( false )
      } else if ( idCartaoDeCreditoSelecionado === ID_ADICIONAR_NOVO_CARTAO && !isEmptyObject( novoCartaoCredito ) ) {
        setCadastrouNovoCartao( true )
        cartaoSelecionado = novoCartaoCredito
      }

      if ( cartaoSelecionado ) {
        const isPlanoAnual = !isEmptyObject( dadosEtapas[ ETAPA_PLANO ] ) && dadosEtapas[ ETAPA_PLANO ].tipo === PLANO_ANUAL.visualizacao
        const dadosPagamentoPlano = getDadosPagamentoPlano()
        setPagamentoSelecionado( {
          ...cartaoSelecionado,
          'metodoPagamento': METODO_PAGAMENTO_CARTAO.slug,
          'parcela': isPlanoAnual ? PARCELA_PADRAO_ANUAL : PARCELA_PADRAO_TRIMESTRAL,
          'plano': {
            'id': dadosPagamentoPlano.id,
            'tipo': dadosPagamentoPlano.tipo,
            'valor': dadosPagamentoPlano.valor
          },
        } )
      }
    }
  }, [ cartoesCadastrados, idCartaoDeCreditoSelecionado, novoCartaoCredito ] )

  const getDadosPagamentoPlano = () => {
    const [ planoCartao ] = listaPlanosPorModalidade[ tiposDePlanos.NAO_PRESENTE ]
      .filter( plano => plano.metodosPagamento.includes( METODO_PAGAMENTO_CARTAO.visualizacao ) && plano.tipo === dadosEtapas[ ETAPA_PLANO ].tipo )
      .sort( ( planA, planB ) => planA.tipo < planB.tipo ? -1 : 1 )
    return ( {
      'id': planoCartao.id,
      'tipo': planoCartao.tipo,
      'valor': planoCartao.valorTotal,
    } )
  }

  if ( cartoesCadastrados ) {
    if ( cartoesCadastrados.length ) {
      return (
        <Fragment>
          <p>{DESCRICAO_ESCOLHA_CARTAO_CREDITO}</p>

          <EscolhaCartoesExistentes
            idCartaoDeCreditoSelecionado={ idCartaoDeCreditoSelecionado }
            novoCartaoCredito={ novoCartaoCredito }
            setIdCartaoDeCreditoSelecionado={ setIdCartaoDeCreditoSelecionado }
            setNovoCartaoCredito={ setNovoCartaoCredito }
          />

        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <p>{ DESCRICAO_ESCOLHA_CARTAO_NOVO }</p>

          <EscolhaNovoCartao
            idCartaoDeCreditoSelecionado={ idCartaoDeCreditoSelecionado }
            novoCartaoCredito={ novoCartaoCredito }
            setIdCartaoDeCreditoSelecionado={ setIdCartaoDeCreditoSelecionado }
            setNovoCartaoCredito={ setNovoCartaoCredito }
          />
        </Fragment>
      )
    }
  }

  return (
    <InlineLoader
      cor={ temaFluxo }
      isCenter
    />
  )
}

PagamentoComCartaoCredito.propTypes = {
  'etapaAtual': object.isRequired,
  'setCadastrouNovoCartao': func.isRequired,
  'setPagamentoSelecionado': func.isRequired
}

export default PagamentoComCartaoCredito
